/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useSwipeable } from "react-swipeable";
import {
  IconContainer,
  LeftIcon,
  MediaSliderContainer,
  RightIcon,
  Row,
  GiftBoxImageContainer,
  Image,
  LinesContainer,
  FillLine,
  Line,
  TextContainer,
  SmallText,
  Button,
} from "./MediaBannerSlider.styles";
import { useTranslation } from "react-i18next";
import { categoriesData } from "../../store/slices/marketplace/marketplaceSlice";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { normalizeCategoryName } from "../../utils/utils";

const MediaBannerSlider = ({
  images,
  activeIndex,
  setActiveIndex,
  timer,
  total,
  ar,
}) => {
  const [fillWidth, setFillWidth] = useState(0);
  const fillWidthRef = useRef(0);
  const { t } = useTranslation();
  const categories = useSelector(categoriesData);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!timer) return;

    fillWidthRef.current = 0;
    setFillWidth(0);

    const interval = setInterval(() => {
      fillWidthRef.current += 0.5;
      if (fillWidthRef.current >= 48) {
        fillWidthRef.current = 0;
        setFillWidth(0);
        setActiveIndex((prev) => (prev + 1) % total);
      } else {
        setFillWidth(fillWidthRef.current);
      }
    }, timer / 128);

    return () => clearInterval(interval);
  }, [timer, activeIndex, total]);

  const previousSlide = () => {
    const newIndex = activeIndex === 0 ? images.length - 1 : activeIndex - 1;
    setActiveIndex(newIndex);
    fillWidthRef.current = 0;
    setFillWidth(0);
  };

  const nextSlide = () => {
    const newIndex = activeIndex === images.length - 1 ? 0 : activeIndex + 1;
    fillWidthRef.current = 0;
    setFillWidth(0);
    setActiveIndex(newIndex);
  };

  const [translateXImage, setTranslateXImage] = useState("100%");

  useEffect(() => {
    if (!ar) {
      setTranslateXImage(`-${activeIndex * 100}%`);
    } else {
      setTranslateXImage(`${activeIndex * 100}%`);
    }
  }, [activeIndex, ar]);

  const swipeHandlers = useSwipeable({
    onSwipedLeft: nextSlide,
    onSwipedRight: previousSlide,
    preventDefaultTouchmoveEvent: true,
    trackMouse: true,
  });

  const handleExploreNowNavigate = () => {
    const activeCategoryName = images[activeIndex]?.categoryName;
    if (!activeCategoryName) return;

    const normalizedBannerCategory = normalizeCategoryName(activeCategoryName);

    let categoryExist = categories?.find(
      (c) => normalizeCategoryName(c.name) === normalizedBannerCategory,
    );

    if (!categoryExist) {
      for (const cat of categories ?? []) {
        const sub = cat?.subcategories?.find(
          (s) => normalizeCategoryName(s.name) === normalizedBannerCategory,
        );
        if (sub) {
          categoryExist = sub;
          break;
        }
      }
    }
    if (categoryExist) {
      const params = new URLSearchParams(location.search);
      params.set("category", categoryExist.id);
      navigate(`${location.pathname}?${params.toString()}`, {
        replace: true,
      });
    }
  };

  return (
    <GiftBoxImageContainer {...swipeHandlers}>
      <TextContainer>
        <SmallText>{t("new-occasion")}</SmallText>
        <Button onClick={handleExploreNowNavigate}>{t("explore-now")}</Button>
      </TextContainer>
      <MediaSliderContainer>
        {images.length > 1 && (
          <Row>
            <IconContainer onClick={previousSlide} $right={ar}>
              {ar ? <RightIcon /> : <LeftIcon />}
            </IconContainer>
            <IconContainer onClick={nextSlide} $right={!ar}>
              {ar ? <LeftIcon /> : <RightIcon />}
            </IconContainer>
          </Row>
        )}

        {(() => {
          const imagesList = [];
          for (let i = 0; i < images.length; i++) {
            imagesList.push(
              <Image
                key={images[i].id}
                style={{
                  transform: `translateX(${translateXImage})`,
                }}
                src={images[i].url}
                alt={`slider-photo-${i}`}
              />,
            );
          }
          return imagesList;
        })()}
      </MediaSliderContainer>
      {images.length > 1 && (
        <LinesContainer>
          {Array.from({ length: total }).map((_, index) => (
            <Line
              style={{
                transform: ar ? "scaleX(-1)" : "none",
              }}
              $active={index < activeIndex}
              key={index}
              onClick={(event) => {
                event.stopPropagation();
                setActiveIndex(index);
                fillWidthRef.current = 0;
                setFillWidth(0);
              }}
            >
              {index === activeIndex && (
                <FillLine
                  style={{
                    transform: ar ? "scaleX(-1)" : "none",
                    transition: "width 0.3s linear",
                    width: `${fillWidth}px`,
                  }}
                />
              )}
            </Line>
          ))}
        </LinesContainer>
      )}
    </GiftBoxImageContainer>
  );
};

export default MediaBannerSlider;
